import * as React from 'react';
import { Modal, Button } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import useModal from 'hooks/useModal';

// TODO: Move <Modal /> into our codebase and fix
export const ModalWithZindex = styled(Modal)`
  .ModalOverlay {
    z-index: ${themeGet('zIndices.modalOverlay')};
  }
`;

const GlobalModal: React.FC = () => {
  const { modal, hideModal } = useModal();

  if (!modal) {
    return null;
  }

  const { variant, header, body, button, onClose, onButtonClick } = modal;

  const handleClose = () => {
    onClose?.({ actionButtonClicked: false });
    hideModal();
  };

  const handleButtonClick = () => {
    onButtonClick?.();
    onClose?.({ actionButtonClicked: true });
    hideModal();
  };

  return (
    <ModalWithZindex isOpen ariaHideApp={false} onRequestClose={handleClose}>
      <Modal.header variant={variant}>{header}</Modal.header>
      <Modal.body>{body}</Modal.body>
      <Modal.footer>
        <Button variant="primary" onClick={handleButtonClick}>
          {button}
        </Button>
      </Modal.footer>
    </ModalWithZindex>
  );
};

export default GlobalModal;
